import type { NotFoundUiContent } from '../../not-found-ui-content';

export const notFound: NotFoundUiContent = {
  eyebrow: 'Orria ez da aurkitu',
  title: 'Ezin izan dugu orri hori aurkitu',
  body: 'Baliteke esteka zaharkituta egotea, edo orria kendu izana. Esan iezaguzu zer bilatzen duzun, eta aurkituko dugu.',
  suggestionsTitle: 'Agian hauetakoren bat bilatzen duzu',
  bestMatchTitle: 'Agian hau esan nahi zenuen',
  prefillHint: 'Saiatu zaren helbidetik aurrez betea',
  goHome: 'Hasiera',
  browseAll: 'Kategoria guztiak',
  reportBrokenLink: 'Jakinarazi esteka hautsi bat',
  noticeTitle: 'Orri hori ez dago eskuragarri',
  noticeSearching: '{query} bilatzen ari gara horren ordez…',
  noticePrefilled: 'Bilatu {query} behean, edo esan iezaguzu zer bilatzen duzun.',
  errorTitle: 'Zerbait gaizki joan da',
  errorBody: 'Ezin izan dugu orri hau kargatu. Saiatu berriro, edo bilatu behean behar duzuna.',
  retry: 'Saiatu berriro',
  streamLostTitle: 'Ezin izan dugu orri hau amaitu',
  streamLostBody: 'Bilaketa orria gorde aurretik gelditu da. Abiarazi berriro, eta zure hitzetatik abiatuta berrekingo diogu.',
  relaunch: 'Bilatu berriro',
};
